import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { InjectableSuperclass } from '@sama/ng-core';
import { isEmpty } from 'lodash';
import { TaskWorkspaceStore } from '../../../h3ml/state/task-workspace-store';
import { UndoService } from '../../../outputs/annotation/annotation-shared/toolbars/static-toolbar/undo.service';
import { RootUndoService } from '../../../shared/misc-services/root-undo.service';
import { AnnotationsService } from '../../services/annotations.service';
import { EscapeKeyboardShortcutService } from '../../services/escape-keyboard-shortcut.service';
import { ItemService } from '../../services/item.service';
import { BulkEditViewComponent } from '../bulk-edit-view/bulk-edit-view.component';
import { ReadOnlyTableComponent } from '../read-only-table/read-only-table.component';

@Component({
  selector: 'h3-categorization-container',
  templateUrl: './categorization-container.component.html',
  styleUrl: './categorization-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, ReadOnlyTableComponent, BulkEditViewComponent],
  providers: [
    {
      provide: UndoService,
      useExisting: RootUndoService,
    },
    ItemService,
    EscapeKeyboardShortcutService,
    AnnotationsService,
  ],
})
export class CategorizationContainerComponent extends InjectableSuperclass {
  private readonly store = inject(TaskWorkspaceStore);

  protected isAnnotationPanelOpen$ = this.store(
    'categorizationAnnotationPanel',
  )('isOpen').$;

  constructor() {
    super();
    inject(EscapeKeyboardShortcutService).register();

    this.subscribeToAnnotationPanelOpen();
  }

  private subscribeToAnnotationPanelOpen() {
    this.subscribeTo(this.store('objectSelection').$, (objectSelection) => {
      this.store('categorizationAnnotationPanel')('isOpen').set(
        !isEmpty(objectSelection),
      );
    });
  }
}
